module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_10.dot-de43d7ecd1e97cd9c5ea29e78ac3f684.svg";